class RefundData {
    constructor(payment, refundAmount) {
        this.payment = payment;
        this.refundAmount = refundAmount;
    }
}

module.exports = RefundData;
